import { useProductCard } from '../ProductCardContext';
import { CLASSNAME, formatCurrency } from '@skin-seoul/service';
import { Convert } from '@skin-seoul/utils';

export const ProductCardInfoPrice = () => {
  const { currency, originalPrice, salePrice } = useProductCard();

  return (
    <div className="flex flex-row items-center gap-2 flex-wrap">
      {salePrice ? (
        <Convert
          value={salePrice}
          formatter={(salePrice) => (
            <>
              <p
                className={`text-neutral-700 text-paragraph-large font-semibold whitespace-nowrap ${CLASSNAME.NOT_TRANSLATE}`}
              >
                {formatCurrency(currency, salePrice)}
              </p>
              <p
                className={`text-neutral-400 text-label-medium font-normal line-through whitespace-nowrap ${CLASSNAME.NOT_TRANSLATE}`}
              >
                {formatCurrency(currency, originalPrice)}
              </p>
            </>
          )}
        />
      ) : (
        <p className={`text-paragraph-large font-semibold text-neutral-700 ${CLASSNAME.NOT_TRANSLATE}`}>
          {formatCurrency(currency, originalPrice)}
        </p>
      )}
    </div>
  );
};
